import React from "react";
import { Table } from "react-bootstrap";
import "./DashboardComponents.css";

// Phase 5, §31. Generic "one row per user/entity" breakdown table. `rows`
// is an array of plain objects; `columns` is [{key, label}] — never lets
// the caller pass arbitrary HTML, only plain values.
export default function MetricBreakdownTable({ rows, columns }) {
  if (!rows || rows.length === 0) {
    return (
      <div className="perf-empty-state">
        <i className="fa-solid fa-table-list" aria-hidden="true"></i>
        <p>No breakdown data available.</p>
      </div>
    );
  }

  return (
    <div className="table-responsive perf-breakdown-table-wrap">
      <Table size="sm" hover className="mb-0 perf-breakdown-table">
        <thead>
          <tr>
            {columns.map((c) => <th key={c.key}>{c.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={row.id ?? i}>
              {columns.map((c) => (
                <td key={c.key}>{row[c.key] === null || row[c.key] === undefined ? <span className="perf-not-available">Not Available</span> : String(row[c.key])}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
